import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  ActionSheetController,
  AlertController,
  IonicModule,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
} from "@ionic/angular";
import { ToastController } from "@ionic/angular/standalone";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { NotificacaoDetalhePage } from "./notificacao-detalhe/notificacao-detalhe.page";
import { AcompanhamentoPage } from "../acompanhamento/acompanhamento.page";
import { CultoDetalhesPage } from "../culto/culto-detalhes/culto-detalhes.page";
import { GrupoDetalhesPage } from "../grupo/grupo-detalhes/grupo-detalhes.page";
import { MdaDetalhesPage } from "../mda/mda-detalhes/mda-detalhes.page";
import { MensagemDetailPage } from "../mensagem/mensagem-detail/mensagem-detail.page";
import { NoticiaDetalhesPage } from "src/app/components/noticia-detalhes/noticia-detalhes.page";
import { EventoDetalhesPage } from "../evento/evento-detalhes/evento-detalhes.page";
import { AniversariantesPage } from "../aniversariantes/aniversariantes.page";
import { EnqueteListaPage } from "../enquete-lista/enquete-lista.page";
import { Browser } from "@capacitor/browser";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";

@Component({
  selector: "app-notificacao",
  templateUrl: "./notificacao.page.html",
  styleUrls: ["./notificacao.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    DateFormatPipe,
    LoadingSpinnerComponent,
    AcompanhamentoPage,
    CultoDetalhesPage,
    // GrupoDetalhesPage,
    MdaDetalhesPage,
    MensagemDetailPage,
    NoticiaDetalhesPage,
    // EventoDetalhesPage,
    AniversariantesPage,
    EnqueteListaPage,
    SemRegistroComponent,
  ],
})
export class NotificacaoPage implements OnInit {
  notifications: Array<any>;
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public pessoaProvider: PessoaProvider,
    public modalCtrl: ModalController,
    private translate: TranslateService,
    public loadingController: LoadingController,
    private toastCtrl: ToastController,
    private actionSheetCtrl: ActionSheetController,
    private alertCtrl: AlertController
  ) {
    this.navParams.get("idPessoa");
  }

  ngOnInit(): void {
    this.reloadNotification();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  reloadNotification() {
    this.pessoaProvider.getNotification().subscribe({
      next: (result) => {
        this.notifications = result;

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      },
      error: (err) => {
        console.error("Erro ao buscar notificações:", err);
        this.loaded = true;
      },
    });
  }

  async showToast(message: string, color = "danger") {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color: color,
      position: "bottom",
    });
    await toast.present();
  }

  leitura(notification: any) {
    if (!notification.dataLido) {
      this.pessoaProvider.updateNotification(notification.id).subscribe(
        (result) => {
          if (result.success) {
            this.atualizarNotificacao(notification.id);
            this.tratarPush(notification.dadosApp, notification.url);
          }
        },
        (error) => {
          console.error("Erro ao marcar notificação como lida", error);
        }
      );
    } else {
      this.tratarPush(notification.dadosApp, notification.url, notification);
    }
  }

  lerTodas() {
    this.pessoaProvider.updateNotificationAll().subscribe(
      (result) => {
        if (result.success) {
          this.showToast('Todas as notificações foram marcadas como lida', "success");
          this.reloadNotification();
        } else {
          this.showToast(result.message, "light");
        }
      },
      (error) => {
        console.error("Erro ao marcar notificação como lida", error);
      }
    );
  }

  async updateAll() {
    (
      await this.actionSheetCtrl.create({
        header: this.translate.instant('Opções'),
        buttons: [
          {
            text: this.translate.instant('Marcar todos como lida'),
            handler: () => {
              this.lerTodas();
            },
          },
          {
            text: this.translate.instant('cancelar'),
            role: 'destructive',
          },
        ],
      })
    ).present();
  }

  async alert(notification: any) {
    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: "Atenção",
      message: "Deseja remover essa notificação?",
      buttons: [
        {
          text: "Sim",
          handler: () => {
            this.delete(notification);
          },
        },
        {
          text: "Não",
          role: "cancel",
        },
      ],
    });

    await alert.present();
  }

  delete(notification: any) {
    this.pessoaProvider.deleteNotification(notification.id).subscribe(
      (result) => {
        if (result) {
          this.showToast("Notificação removida com sucesso.", "success");
          this.removeNotificationFromList(notification.id);
        } else {
          this.showToast("Não foi possível remover a notificação.");
        }
      },
      (error) => {
        console.error("Erro ao remover a notificação", error);
        this.showToast("Erro ao remover a notificação. Tente novamente.");
      }
    );
  }

  removeNotificationFromList(id: number) {
    this.notifications = this.notifications.filter(
      (notification) => notification.id !== id
    );
  }

  private atualizarNotificacao(idNotification: number) {
    const updatedNotification = this.notifications.find(
      (notification) => notification.id === idNotification
    );
    if (updatedNotification) {
      updatedNotification.dataLido = new Date().toISOString();
    }
  }

  tratarPush(notification: any, url = null, detalhes = null) {
    const jsonPush = JSON.parse(notification);

    if (notification) {
      const modalConfig = {
        culto: {
          page: CultoDetalhesPage,
          data: {
            idCulto: jsonPush.idEntidade,
            dataInicio: jsonPush.extras.dataInicio,
            idCultoAgenda: 0,
          },
        },
        cultoagenda: {
          page: CultoDetalhesPage,
          data: {
            idCulto: jsonPush.extras.idCulto,
            dataInicio: jsonPush.extras.dataInicio,
            idCultoAgenda: jsonPush.idEntidade,
          },
        },
        grupo: {
          page: GrupoDetalhesPage,
          data: {
            id: jsonPush.idEntidade,
            tipo: "1",
            aba: jsonPush.extras.aba,
          },
        },
        ministerio: {
          page: GrupoDetalhesPage,
          data: {
            id: jsonPush.idEntidade,
            tipo: "2",
            aba: jsonPush.extras.aba,
          },
        },
        mda: {
          page: MdaDetalhesPage,
          data: { id: jsonPush.idEntidade },
        },
        mensagem: {
          page: MensagemDetailPage,
          data: { id: jsonPush.idEntidade },
        },
        oracao:
          jsonPush.extras.equipe === "1"
            ? { page: "OracaoAdmPage", data: {} }
            : { page: "OracaoPage", data: {} },
        noticia: {
          page: NoticiaDetalhesPage,
          data: { id: jsonPush.idEntidade },
        },
        evento: {
          page: EventoDetalhesPage,
          data: { id: jsonPush.idEntidade, tipo: "1" },
        },
        ensino: {
          page: EventoDetalhesPage,
          data: { id: jsonPush.idEntidade, tipo: "2" },
        },
        aniversariantes: {
          page: AniversariantesPage,
          data: {},
        },
        enquete: {
          page: EnqueteListaPage,
          data: { idEnquete: jsonPush.idEntidade },
        },
        acompanhamento: {
          page: AcompanhamentoPage,
          data: {},
        },
        relogioOracao: {
          page: "relogioOracao",
        },
      };

      const entidade = jsonPush.entidade as keyof typeof modalConfig;
      const config = modalConfig[entidade];

      if (
        config.page == EventoDetalhesPage ||
        config.page == "relogioOracao" ||
        config.page == AcompanhamentoPage
      ) {
        this.openModal(config, url, detalhes);
      } else {
        this.openPage(config, url);
      }
    }
  }

  async openModal(config: any, url: null, detalhes: null) {
    const actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant("Opções"),
      buttons: [
        {
          text: this.translate.instant("Abrir Notificação"),
          handler: () => {
            this.openPage(config, url);
          },
        },
        {
          text: this.translate.instant("Detalhes da Notificação"),
          handler: async () => {
            const data = { detalhes: detalhes };
            const modalPage = await this.modalCtrl.create({
              component: NotificacaoDetalhePage,
              componentProps: data,
            });
            modalPage.present();
          },
        },
        {
          text: "Cancelar",
          handler: () => {
            actionSheet.dismiss();
          },
        },
      ],
    });

    await actionSheet.present();
  }

  async openPage(config: any, url: any) {
    if (config.page === "relogioOracao") {
      Browser.open({ url: url });
    }

    if (config) {
      const modal = await this.modalCtrl.create({
        component: config.page,
        componentProps: config.data || {},
      });
      await modal.present();
    }
  }
}
